import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IUser } from "@/shared/api/users"
import { FillProfileState } from "./types"

const initialState: FillProfileState = {
    isOpen: false,
    currentUser: null,
    onSuccess: null
}

interface OpenFillProfilePayload {
    user: IUser
    onSuccess?: () => void
}

const fillProfileSlice = createSlice({
    name: 'fillProfile',
    initialState,
    reducers: {
        openFillProfileModal: (state, action: PayloadAction<OpenFillProfilePayload>) => {
            state.isOpen = true
            state.currentUser = action.payload.user as any
            state.onSuccess = action.payload.onSuccess ?? null
        },
        closeFillProfileModal: (state) => {
            state.isOpen = false
        }
    }
})

export default fillProfileSlice.reducer
export const { openFillProfileModal, closeFillProfileModal } = fillProfileSlice.actions
